import { Switch } from "@material-tailwind/react";

export function SwitchDisabled() {
  return <Switch disabled={true} />;
}
